<template>
  <Modal
    confirmText="Okej"
    @cancel="$emit('close')"
    @confirm="$emit('close')"
    size="sm"
    :noMargin="true"
    :addSpace="false"
  >
    <div class="flex flex-col items-center text-center">
      <div class="mb-8 w-full">
        <img
          :src="mobileImage"
          alt="Mobile menu view"
          class="w-full max-h-[45vh] object-cover md:hidden"
        />
        <img
          :src="desktopImage"
          alt="Desktop menu view"
          class="w-full max-h-[45vh] object-cover hidden md:inline"
        />
        <div class="flex flex-col items-start gap-3 px-6 py-6">
          <div class="text-label mt-4">
            <span
              class="px-2 py-1 rounded-sm"
              :class="'text-black bg-primary'"
            >
              NYTT
            </span>
          </div>
          <h3 class="text-t5 md:text-t5 text-left">{{webapp_config.msg.onboarding_title}}</h3>
          <p class="text-b2 text-left" v-html="webapp_config.msg.onboarding_text"></p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/modal';
import {mapGetters} from "vuex";

export default {
  name: 'OnboardingModal',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters([
      'webapp_config'
    ]),
  },
  data() {
    return {
      desktopImage: 'https://tstabgmypagescode.blob.core.windows.net/test-exit-xpand/drop/static/images/onboarding.png',
      mobileImage: 'https://tstabgmypagescode.blob.core.windows.net/test-exit-xpand/drop/static/images/onboarding.png',
    };
  },
};
</script>
